module.exports = __webpack_public_path__ + "static/media/PESPHOTO.3aa5123c.jpg";